import { ChangeEventHandler, FC, useCallback } from 'react';
import './Field.css';

export interface FieldProps {
  label: string;
  value: string | undefined;
  required?: boolean;
  updater: (value: string) => void;
  disabled?: boolean;
}

export const Field: FC<FieldProps> = ({
  label,
  required,
  value,
  updater,
  disabled,
}) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (event) => {
      updater(event.target.value);
    },
    [updater]
  );

  return (
    <div className="Field">
      <label>
        {label}
        {required && <span className="Required">*</span>}:
      </label>
      <input value={value} onChange={handleChange} disabled={disabled} />
    </div>
  );
};
